import { DIAS_SEMANA, NOMES_MESES, parseDataLocal } from '../utils'

interface MiniCalendarioMarcacoesProps {
  /** Datas marcadas em ISO (yyyy-MM-dd). */
  datas: string[]
}

interface MesInfo {
  ano: number
  mes: number // 1-12
  diasMarcados: Set<number>
}

function agruparPorMes(datas: string[]): MesInfo[] {
  const mapa = new Map<string, MesInfo>()
  for (const iso of datas) {
    const d = parseDataLocal(iso)
    const chave = `${d.getFullYear()}-${d.getMonth() + 1}`
    if (!mapa.has(chave)) {
      mapa.set(chave, { ano: d.getFullYear(), mes: d.getMonth() + 1, diasMarcados: new Set() })
    }
    mapa.get(chave)!.diasMarcados.add(d.getDate())
  }
  return Array.from(mapa.values()).sort((a, b) => (a.ano - b.ano) || (a.mes - b.mes))
}

function MesGrid({ info }: { info: MesInfo }) {
  const primeiro = new Date(info.ano, info.mes - 1, 1)
  const totalDias = new Date(info.ano, info.mes, 0).getDate()
  const blanks = Array.from({ length: primeiro.getDay() })
  const dias = Array.from({ length: totalDias }, (_, i) => i + 1)

  return (
    <div className="w-56">
      <p className="text-xs font-semibold text-gray-700 mb-2 text-center">
        {NOMES_MESES[info.mes - 1]} {info.ano}
      </p>
      <div className="grid grid-cols-7 gap-0.5 mb-1">
        {DIAS_SEMANA.map((d) => (
          <div key={d} className="text-center text-[9px] font-medium text-gray-400 uppercase">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-0.5">
        {blanks.map((_, i) => <div key={`b${i}`} />)}
        {dias.map((n) => {
          const marcado = info.diasMarcados.has(n)
          return (
            <div
              key={n}
              className={`aspect-square rounded flex items-center justify-center text-[10px] ${
                marcado ? 'bg-blue-500 text-white font-semibold' : 'text-gray-400'
              }`}
            >
              {n}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export function MiniCalendarioMarcacoes({ datas }: MiniCalendarioMarcacoesProps) {
  const meses = agruparPorMes(datas)
  if (meses.length === 0) return null
  return (
    <div className="flex flex-wrap gap-4 p-2">
      {meses.map((info) => (
        <MesGrid key={`${info.ano}-${info.mes}`} info={info} />
      ))}
    </div>
  )
}
